import { useIsMobile } from "@/hooks/use-mobile";
import DesktopLanding from "@/pages/DesktopLanding";

interface DesktopGateProps {
  children: React.ReactNode;
}

/**
 * On desktop (viewport ≥ 768 px) the mobile app is hidden and only
 * the promotional landing page is shown. On mobile devices the children
 * (the full app) render as normal.
 */
export function DesktopGate({ children }: DesktopGateProps) {
  const isMobile = useIsMobile(); // synchronous init → no flash

  if (!isMobile) {
    return <DesktopLanding />;
  }

  return <>{children}</>;
}
